import logo from './logo.svg';
import './App.css';
import R5KarateLanding from './R5KarateInstitute'
function App() {
  return (
    <div className="App">
      <R5KarateLanding/>
    </div>
  );
}

export default App;
